import { useCallback, useState } from 'react';
import { useMediaQuery } from '@/shared/hooks/useMediaQuery';
import type { ObjectView } from './objectOverview';

const storageKey = 'stayon.objects-view';

function readStored(): ObjectView {
  return localStorage.getItem(storageKey) === 'cards' ? 'cards' : 'list';
}

/**
 * View-Präferenz (Liste/Karten) — lokal pro Browser gespeichert, enthält keine
 * fachlichen Daten. Auf kleinen Bildschirmen sind Karten erzwungener Standard;
 * die gespeicherte Desktop-Präferenz bleibt dabei unangetastet.
 */
export function useObjectView() {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const [storedView, setStoredView] = useState<ObjectView>(readStored);

  const setView = useCallback((next: ObjectView) => {
    setStoredView(next);
    localStorage.setItem(storageKey, next);
  }, []);

  return { view: isMobile ? 'cards' : storedView, storedView, setView, isMobile };
}
